<template>
  <VirtualList :items="items" :itemSize="itemSize" ref="list">
    <template slot="header">
      <div class="c-virtual-list__head">
        <div class="c-virtual-list__col check"></div>
        <div class="c-virtual-list__col keyword">キーワード</div>
        <ThSort
          v-model="temp.sort"
          name="rank"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col rank"
          @change="change"
        >
          平均順位
        </ThSort>
        <ThSort
          v-if="isInflux"
          v-model="temp.sort"
          name="searchVolume"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col searchVolume"
          @change="change"
        >
          月間検索数
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="impressions"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col impressions"
          @change="change"
        >
          表示回数
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="ctr"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col ctr"
          @change="change"
        >
          クリック率
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="influx"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col influx"
          @change="change"
        >
          流入数
        </ThSort>
        <ThSort
          v-if="isConversionDirect"
          v-model="temp.sort"
          name="directConversion"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col cv"
          @change="change"
        >
          直接CV
        </ThSort>
        <ThSort
          v-if="isConversionAssisted"
          v-model="temp.sort"
          name="assistedConversion"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col cv"
          @change="change"
        >
          間接CV
        </ThSort>
        <ThSort
          v-if="isConversionDirect"
          v-model="temp.sort"
          name="directConversionRate"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col cvr"
          @change="change"
        >
          直接CVR
        </ThSort>
        <ThSort
          v-if="isConversionAssisted"
          v-model="temp.sort"
          name="assistedConversionRate"
          orderby="desc"
          tag="div"
          type="number"
          class="c-virtual-list__col cvr"
          @change="change"
        >
          間接CVR
        </ThSort>
        <ThSort
          v-model="temp.sort"
          name="url"
          orderby="asc"
          tag="div"
          type="string"
          class="c-virtual-list__col url"
          @change="change"
        >
          流入先URL
        </ThSort>
        <ThSort
          v-if="isInflux"
          v-model="temp.sort"
          name="title"
          orderby="asc"
          tag="div"
          type="string"
          class="c-virtual-list__col title"
          @change="change"
        >
          タイトル
        </ThSort>
      </div>
    </template>
    <template slot="before">
      <div v-if="isLoading" class="c-virtual-list__guide">
        <div class="c-virtual-list__col l-p-0">
          <LoadingChara variant="inline">
            <template slot="title">
              データ取得中
            </template>
          </LoadingChara>
        </div>
      </div>
      <div v-else-if="!items.length" class="c-virtual-list__guide">
        <div class="c-virtual-list__col c-text--center">
          <template v-if="hasData">
            条件に合うデータがありません。
          </template>
          <template v-else>
            データがありません。
          </template>
        </div>
      </div>
    </template>
    <template v-slot="{ item }">
      <ListItemKeyword
        :key="item.index"
        :checked="checked"
        :conversionType="conversionType"
        :dataType="dataType"
        :item="item"
        :project="project"
        @check="updateChecked"
      />
    </template>
  </VirtualList>
</template>

<script>
import ListItemKeyword from '@/components/siteKeywordAnalysis/ListItemKeyword';
import LoadingChara from '@/components/LoadingChara';
import ThSort from '@/components/ThSort';
import VirtualList from '@/components/VirtualList';
import { scroller } from 'vue-scrollto/src/scrollTo';

export default {
  props: {
    checked: {
      type: Array,
      required: true
    },
    conversionType: {
      type: String,
      required: true
    },
    dataType: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    sort: {
      type: Object,
      required: true
    },
    hasData: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    ListItemKeyword,
    LoadingChara,
    ThSort,
    VirtualList
  },
  data() {
    return {
      itemSize: 43,
      scroller: scroller(),
      temp: {
        sort: Object.assign({}, this.sort)
      },
      timer: null
    };
  },
  computed: {
    isConversion() {
      return this.dataType === 'conversion';
    },
    isConversionAssisted() {
      return this.isConversion && this.conversionType === 'assisted';
    },
    isConversionDirect() {
      return this.isConversion && this.conversionType === 'direct';
    },
    isInflux() {
      return this.dataType === 'influx';
    }
  },
  watch: {
    items: {
      handler() {
        this.$nextTick(() => {
          this.$refs.list.scrollToStart();
        });
      }
    },
    sort: {
      handler(value) {
        this.temp.sort = Object.assign({}, value);
      }
    }
  },
  methods: {
    blinkRow(index) {
      const els = document.querySelectorAll('#item_' + index);
      // バーチャルリストの都合で複数存在することがあるため
      els.forEach(el => {
        el.classList.remove('is-blink');
        // blink消してすぐ付けてもblinkしないことがあるため
        setTimeout(() => {
          el.classList.add('is-blink');
        }, 0);
      });
    },
    change() {
      this.$emit('sort', this.temp.sort);
    },
    scrollToRow(target) {
      const index = this.items.findIndex(item => item.id === target.id);
      if (index === -1) {
        return;
      }
      clearTimeout(this.timer);

      const _this = this;
      const scroller = this.$refs.list.$refs.scroller;
      const scrollTop = index * scroller.itemSize;

      if (scrollTop !== scroller.$el.scrollTop) {
        this.scroller(scroller.$el, 500, {
          container: scroller.$el,
          offset: scrollTop,
          onDone(element) {
            _this.timer = setTimeout(() => {
              _this.blinkRow(target.index);
            }, 300);
          }
        });
      } else {
        this.blinkRow(target.index);
      }
    },
    updateChecked(checked) {
      this.$emit('check', checked);
    }
  }
};
</script>
